import api from "@/services/api";

const state = {
  trialBalance: null,
  balanceSheet: null,
  generalLedger: null,
  accrualPnl: null,
};

const mutations = {
  SET_TRIAL_BALANCE(state, data) {
    state.trialBalance = data;
  },
  SET_BALANCE_SHEET(state, data) {
    state.balanceSheet = data;
  },
  SET_GENERAL_LEDGER(state, data) {
    state.generalLedger = data;
  },
  SET_ACCRUAL_PNL(state, data) {
    state.accrualPnl = data;
  },
};

const actions = {
  async getTrialBalance({ commit }, params = {}) {
    try {
      const res = await api.get("/ledger/trial-balance", { params });
      commit("SET_TRIAL_BALANCE", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching trial balance:", error.message);
      throw error;
    }
  },

  async getBalanceSheet({ commit }, params = {}) {
    try {
      const res = await api.get("/ledger/balance-sheet", { params });
      commit("SET_BALANCE_SHEET", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching balance sheet:", error.message);
      throw error;
    }
  },

  async getGeneralLedger({ commit }, { accountId, from, to }) {
    try {
      const res = await api.get(`/ledger/general-ledger/${accountId}`, { params: { from, to } });
      commit("SET_GENERAL_LEDGER", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching general ledger:", error.message);
      throw error;
    }
  },

  async getAccrualPnl({ commit }, params = {}) {
    try {
      const res = await api.get("/ledger/accrual-pnl", { params });
      commit("SET_ACCRUAL_PNL", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching accrual P&L:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
